import React, { useEffect, useState } from "react";


// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";

import Button from "components/CustomButtons/Button.js";
import Table from "components/Table/Table.js";

import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import CardFooter from "components/Card/CardFooter.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import api from "assets/services/api.js";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";

import ModalAddProducts from "components/ModalAddProducts/ModalAddProducts";
import ModalUpdateProducts from "components/ModalUpdateProducts/ModalUpdateProducts";
import ModalDeleteProducts from "components/ModalDeleteProducts/ModalDeleteProducts";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";

import "react-datepicker/dist/react-datepicker.css";
import useAuth from "hooks/useAuth";
import { FaDoorOpen } from "react-icons/fa";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    }
};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);


export default function Products() {

    const classes = useStyles();
    const classes2 = useStyles2();
    const { storageId, garlicType } = useAuth();
    //states data    
    const [products, setProducts] = useState([]);
    //control page
    const [br, setBR] = useState(false);
    const [controlSnack, setControlSnack] = useState(false);
    //states modals
    const [modalShow, setModalShow] = useState(false);
    const [modalShowUpdate, setModalShowUpdate] = useState(false);
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [index, setIndex] = useState({ id: 1 });
    const [importModal, setImportModal] = useState(false);
    useEffect(() => {
        getAllProducts();
    }, []);
    useEffect(() => {
        getAllProducts();
    }, [garlicType]);
    useEffect(() => {
        if (controlSnack) {
            showNotification("br")
        }
    }, [controlSnack]);
    function callModal(index) {
        if (!modalShowUpdate) {
            loadModal();
        };
        setIndex(index);
        setModalShowUpdate(true);
    };
    function callModalDelete(index) {
        if (!modalShowDelete) {
            loadModal();
        };
        setIndex(index);
        setModalShowDelete(true);
    };
    function callModalAdd() {
        if (!modalShow) {
            loadModal();
        };
        setModalShow(true);
    };
    const loadModal = async () => {
        setImportModal(true);
    };
    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 2500);
                }
                break;
            default:
                break;
        }
    };
    async function getAllProducts() {
        try {
            const response = await api.get(`/product/admin/${storageId}?status=true&garlic=${garlicType}`);
            setProducts(response.data);

        } catch (error) {
            alert('erro: ' + error)
        };
    };
    const disabled = async (product) => {
        try {
            const response = await api.post('/product/alter/status', {
                id_admin: storageId,
                id_product: product.id
            });
            if (response.status === 200) {
                getAllProducts();
                setControlSnack(true);
            };
        } catch (error) {
            alert('erro: ' + error)
        };
    };
    function getProductsForTable() {
        let teste = [];
        for (let i = 0; i < products.length; i++) {
            teste[i] = [];
            teste[i].push(products[i].new_code);
            teste[i].push(products[i].name);
            teste[i].push(products[i].box);
            teste[i].push(products[i].weight);
            teste[i].push("R$ " + products[i].standart_price);
            teste[i].push("R$ " + products[i].two_percent);
            teste[i].push("R$ " + products[i].three);
            teste[i].push("R$ " + products[i].max_for_distributors);
            teste[i].push(products[i].gtin);
            teste[i].push(products[i].dun);
            teste[i].push(
                <div className={classes2.tableActions}>
                    <CardIcon>
                        <Icon >{products[i].disabled ? "clear" : "done"}</Icon>
                    </CardIcon>
                    <Tooltip
                        id="tooltip-top"
                        title="Habilitar/desabilitar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Edit"
                            className={classes2.tableActionButton}
                            onClick={() => disabled(products[i])}
                        >
                            <FaDoorOpen
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.edit6
                                }
                            />
                        </IconButton>

                    </Tooltip>
                    <Tooltip
                        id="tooltip-top"
                        title="Editar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Edit"
                            className={classes2.tableActionButton}
                            onClick={() => callModal(products[i])}

                        >
                            <Edit
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.edit
                                }
                            />
                        </IconButton>

                    </Tooltip>
                    : <div />
                    <Tooltip
                        id="tooltip-top-start"
                        title="Deletar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Close"
                            className={classes2.tableActionButton}
                            onClick={() => callModalDelete(products[i])}
                        >
                            <Close
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.close
                                }
                            />
                        </IconButton>
                    </Tooltip>

                </div>
            );
        };
        return teste;
    };
    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color="success">
                                <Icon>content_copy</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <p className={classes.colorCard}>Clique abaixo para adicionar produto ao operador</p>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Button color="success" className={classes.margintp + classes.maxwidht} onClick={() => callModalAdd()}>
                            Adicionar produto
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <Card>
                <CardHeader className={classes.zindex} color={"primary"}>
                    <h4 className={classes.cardTitleWhite}>Produtos destinados a operação</h4>
                    <p className={classes.cardCategoryWhite}></p>
                </CardHeader>
                <CardBody>
                    <Table
                        index={index}
                        tableHeaderColor="primary"
                        tableHead={["Código", "Descrição", "UN caixa", "Peso (KG)", "Preço padrão", "1° porcentagem", "2° porcentagem", "3° porcentagem", "GTIN", "DUN", "Ações"]}
                        tableData={getProductsForTable()}
                    />
                </CardBody>
            </Card>
            <Snackbar
                place="br"
                color="success"
                icon={AddAlert}
                message="Status produto alterado com sucesso"
                open={br}
                closeNotification={() => setBR(false)}
                close
            />
            {importModal && modalShow && (
                <ModalAddProducts key={String("Prd_" + index.id)} props={index} show={modalShow} onHide={() => setModalShow(false)} getAllProducts={getAllProducts} />
            )}
            {importModal && modalShowUpdate && (
                <ModalUpdateProducts key={String("Upd_" + index.id)} props={index} show={modalShowUpdate} onHide={() => setModalShowUpdate(false)} getAllProducts={getAllProducts} />
            )}
            {importModal && modalShowDelete && (
                <ModalDeleteProducts key={String("Del_" + index.id)} props={index} show={modalShowDelete} onHide={() => setModalShowDelete(false)} getAllProducts={getAllProducts} />
            )}
        </GridContainer>
    );

}
